import React from 'react';
import BeforeAfter from './BeforeAfter';
import { PowerContentContainer } from './styled';
import Reports from './Reports';
import ScrollWrapper from '../../ScrollWrapper/ScrollWrapper';

const index = (props) => {
  const { reportsData, beforeAfterData, fromPdp, productId } = props;
  const eventData = {
    category: 'impression_section_in_pdp',
    section_name: 'clinical results',
    section_id: '',
    deeplink_value: null,
    shape: '',
    card_ids: '',
    send_to: '',
  };
  return (
    <PowerContentContainer>
      <ScrollWrapper fromPdp={fromPdp} productId={productId} data={eventData}>
        <BeforeAfter beforeAfterData={beforeAfterData} />
      </ScrollWrapper>
      <Reports reportsData={reportsData} />
    </PowerContentContainer>
  );
};

export default index;
